import { ImpactType } from '../impact/units';

export type ProjectGroupImpactType =
  | ImpactType.CARBON_OFFSETS
  | ImpactType.CARBON_REMOVAL
  | ImpactType.HABITAT_RESTORATION;

export const PROJECT_GROUP_IMPACT_TYPES: ProjectGroupImpactType[] = [
  ImpactType.CARBON_OFFSETS,
  ImpactType.CARBON_REMOVAL,
  ImpactType.HABITAT_RESTORATION,
];
